import { castArray, get } from 'lodash';
import { useState } from 'react';

import { Box } from '@hivebrite/design-system/Box';
import { Button } from '@hivebrite/design-system/Button';
import { TextInput } from '@hivebrite/design-system/Inputs';
import { toast } from '@hivebrite/design-system/Toast';

import { useBooking } from 'hb-react/shared/apps/Events/pages/Booking/hooks/useBooking';
import { useAmplitude } from 'hb-react/shared/hooks/useAmplitude';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

export const PromoCode = () => {
  const [code, setCode] = useState('');

  const { flagEvPaymentsMovePromocode } = useFeatureFlag();
  const { actions, isLoading } = useBooking();
  const { trackEvent } = useAmplitude();

  const onSubmit = async () => {
    try {
      await actions.items.addPromoCode(code);

      trackEvent('NetworkEvents|User enters promo code');

      toast.success(
        s__('Events|Your promo code has been entered successfully!'),
      );
    } catch (error) {
      const errorMessage = castArray(
        get(error, ['response', 'data', 'errors_full_messages']),
      );

      toast.error(errorMessage.join(' - '));
    } finally {
      setCode('');
    }
  };

  if (flagEvPaymentsMovePromocode) {
    return (
      <>
        <Box font="h3-semibold" mb={3}>
          {s__('OrderManagement|Promo code')}
        </Box>
        <Box alignItems="center" flexWrap="wrap">
          <Box mb={5} width="300px" mr={6}>
            <TextInput
              id="promo_code"
              name="promo_code"
              value={code}
              onChange={(event) => setCode(event.target.value.toUpperCase())}
              placeholder={s__('OrderManagement|Insert promo code')}
              clearable
            />
          </Box>
          <Button onClick={onSubmit} isLoading={isLoading} isDisabled={!code}>
            {s__('OrderManagement|Use promo code')}
          </Button>
        </Box>
      </>
    );
  }

  return (
    <>
      <Box font="body-regular-asphalt" mb={3}>
        {s__('Events|Do you have any promotional codes to add to your order?')}
      </Box>
      <Box alignItems="flex-end">
        <Box width="300px" mr={6}>
          <TextInput
            id="promo_code"
            name="promo_code"
            value={code}
            onChange={(event) => setCode(event.target.value.toUpperCase())}
            placeholder={s__('Events|Insert promo code')}
            label={s__('Events|Promo code')}
            clearable
          />
        </Box>
        <Button
          onClick={onSubmit}
          isLoading={isLoading}
          isDisabled={!code}
          mb={1}
        >
          {s__('Events|Use promo code')}
        </Button>
      </Box>
    </>
  );
};
